// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuInlineAddRow{--row-borderColor:transparent;height:var(--row-height,var(--salt-size-base));padding:0 var(--table-selection-bookend-width,4px);display:flex;position:relative}.vuuInlineAddRow .vuuTableCell{height:100%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
